/* eslint-disable @typescript-eslint/unbound-method */
import { getServerPageWebByHostPath } from '@ts/operations-ssr'
import { useRouter } from 'next/router'
import React from 'react'

import { ApolloClient } from '../lib/apolloClient'
import { getServerPageConfig } from '../operations.wp/types-ssr'
import ConfiguredPageProvider, { configuredPageStaticQueries } from './ConfiguredPageProvider'
import PageConfigProvider from './PageConfig/PageConfigProvider'
import { getWebPageByHostPathVariables } from './webpage/WebpageProvider'

const DefaultPageProvider = ({
  children,
  eventSlug,
}: {
  children: React.ReactNode
  eventSlug?: string
}) => {
  const { asPath } = useRouter()

  return (
    <ConfiguredPageProvider withTracking eventSlug={eventSlug} path={asPath}>
      <PageConfigProvider>{children}</PageConfigProvider>
    </ConfiguredPageProvider>
  )
}
export default DefaultPageProvider

export const defaultStaticQueries = async (
  apolloClient: ApolloClient,
  path: string,
  configPath?: string
) => {
  const [
    { webPageConfig },
    {
      props: { data: pageConfig },
    },
    {
      props: { data: webPage },
    },
  ] = await Promise.all([
    configuredPageStaticQueries(apolloClient, configPath || path),
    getServerPageConfig({ context: { wordpress: true } }, apolloClient),
    getServerPageWebByHostPath({ variables: getWebPageByHostPathVariables(path) }, apolloClient),
  ])

  return { pageConfig, webPage, webPageConfig }
}
